import ContentDate from './ContentDate';

export default ContentDate;
